import React from 'react';
import { WifiOutlined, ApiOutlined, AccessTimeOutlined } from '@mui/icons-material';
import './ProfileKpis.css';

// Affiche la date et l'heure exacte de la dernière connexion
const fmt = (ts) => {
  if (!ts) return '—';
  const d = new Date(ts);
  if (isNaN(d)) return '—';
  const now  = new Date();
  const diff = now - d;
  // Moins d'une minute → "À l'instant"
  if (diff < 60_000) return "À l'instant";
  // Même jour → affiche l'heure HH:MM
  const sameDay =
    d.getDate()     === now.getDate()  &&
    d.getMonth()    === now.getMonth() &&
    d.getFullYear() === now.getFullYear();
  if (sameDay) {
    return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  }
  // Hier ou avant → date + heure
  return d.toLocaleString('fr-FR', {
    day:    '2-digit',
    month:  'short',
    hour:   '2-digit',
    minute: '2-digit',
  });
};

const ProfileKpis = ({ stats }) => {
  
  const Pill = ({ icon, label, value, accent }) => (
    <div className={`pk-pill${accent ? ' pk-pill--accent' : ''}`}>
      <span className="pk-icon">{icon}</span>
      <div className="pk-body">
        <span className="pk-value">{value ?? '—'}</span>
        <span className="pk-label">{label}</span>
      </div>
    </div>
  );

  return (
    <div className="pk-row">
      <Pill icon={<WifiOutlined />}       label="Connexions"   value={stats?.total_logins}    accent />
      <Pill icon={<ApiOutlined />}        label="Appels API"   value={stats?.total_api_calls} />
      <Pill icon={<AccessTimeOutlined />} label="Dernière co." value={fmt(stats?.last_login)} />
    </div>
  );
};

export default ProfileKpis;